import { render, staticRenderFns } from "./MRListHandler.vue?vue&type=template&id=d2363f8e"
import script from "./MRListHandler.vue?vue&type=script&lang=ts"
export * from "./MRListHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports